var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(["\n  width: ", ";\n"], ["\n  width: ", ";\n"]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext } from "react";
import styled, { ThemeContext, keyframes } from "styled-components";
import { colorFromTheme, breakPointArrayCleaner, safeElement } from "../../../utils";
import getLuminance from "polished/lib/color/getLuminance.js";
import lighten from "polished/lib/color/lighten.js";
import darken from "polished/lib/color/darken.js";
import { media } from "../../../index";

var ButtonWrapper = function ButtonWrapper(props) {
  var theme = useContext(ThemeContext);

  var bgColor = props.bgColor,
      height = props.height,
      borderColor = props.borderColor,
      borderRadius = props.borderRadius,
      compact = props.compact,
      fluid = props.fluid,
      noHoverAnimation = props.noHoverAnimation,
      forwardedRefSafe = props.forwardedRefSafe,
      restProps = _objectWithoutProperties(props, ["bgColor", "height", "borderColor", "borderRadius", "compact", "fluid", "noHoverAnimation", "forwardedRefSafe"]);

  if (compact) {
    height = 2.5;
  }

  // parse color luminance to calculate hover
  var bgColorParsed = colorFromTheme(bgColor)[0] === "#" ? colorFromTheme(bgColor) : theme.background;
  var lum = getLuminance(bgColorParsed);
  var hoverColor = void 0;
  var clickColor = void 0;
  if (lum < 0.5) {
    hoverColor = lighten(0.05, bgColorParsed);
    clickColor = lighten(0.08, bgColorParsed);
  } else {
    hoverColor = darken(0.05, bgColorParsed);
    clickColor = darken(0.08, bgColorParsed);
  }
  if (props.variant === "tertiary") hoverColor = "none";

  return React.createElement(
    WrapperStyled,
    _extends({
      $as: "button"
      // tabIndex={props.disabled ? "false" : "1"}
      , height: typeof height === "string" ? height : height + "rem",
      bgColor: colorFromTheme(bgColor),
      borderColor: colorFromTheme(borderColor),
      borderRadius: borderRadius + "px",
      fluid: breakPointArrayCleaner(fluid),
      hoverColor: hoverColor,
      clickColor: clickColor,
      noHoverAnimation: noHoverAnimation,
      forwardedRefSafe: forwardedRefSafe
    }, restProps),
    props.children
  );
};

export { ButtonWrapper };
ButtonWrapper.defaultProps = {
  height: 3.5,
  borderRadius: 4,
  compact: false,
  fluid: false,
  bgColor: "red"
};

var animation = keyframes(["0%{transform:scale(1);}25%{transform:scaleX(0.98) scaleY(0.96);}100%{transform:scale(1);}"]);

var WrapperStyled = styled(safeElement()).withConfig({
  displayName: "ButtonWrapper__WrapperStyled",
  componentId: "sc-1hswm7m-0"
})(["position:relative;box-sizing:border-box;display:inline-block;outline:none;padding:0;border:none;background:none;font-family:inherit;font-size:inherit;line-height:inherit;letter-spacing:inherit;cursor:", ";margin:", ";user-select:none;background-color:", ";&:hover{background-color:", ";}&:active{background-color:", ";animation:", " 180ms ease-in-out forwards;}", " height:", ";padding:", ";border-radius:", ";", ";", ";", ";", ";"], function (props) {
  return props.loading || props.disabled ? "normal" : "pointer";
}, function (props) {
  return props.m || "initial";
}, function (props) {
  return props.bgColor;
}, function (props) {
  return props.noHoverAnimation ? props.bgColor : props.hoverColor;
}, function (props) {
  return props.noHoverAnimation ? props.bgColor : props.clickColor;
}, function (props) {
  return props.noHoverAnimation ? "none" : animation;
}, function (props) {
  var hasborderColor = props.borderColor !== "none";
  if (hasborderColor) {
    return "\n      box-shadow: inset 0px 0px 0px 1.5px " + props.borderColor + ";\n      &:focus {\n        box-shadow: inset 0px 0px 0px 1.5px " + props.borderColor + ",\n          0px 0px 0px 4px #BCC1E380;\n      }\n      ";
  } else {
    return "\n      &:focus {\n        box-shadow: 0px 0px 0px 4px #BCC1E380;\n      }\n    ";
  }
}, function (props) {
  return props.height;
}, function (props) {
  return "0 " + props.paddingRight + " 0 " + props.paddingLeft;
}, function (props) {
  return props.borderRadius;
}, media.phone(_templateObject, function (props) {
  return props.fluid[0] ? "100%" : "auto";
}), media.tablet(_templateObject, function (props) {
  return props.fluid[1] ? "100%" : "auto";
}), media.desktop(_templateObject, function (props) {
  return props.fluid[2] ? "100%" : "auto";
}), media.wide(_templateObject, function (props) {
  return props.fluid[3] ? "100%" : "auto";
}));